"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: 1,
  question: "When and where is the wedding?",
  answer: "The wedding will take place on July 11, 2026, at Le Clos de Faqra in Lebanon. The ceremony starts at 5:30 PM."
}, {
  id: 2,
  question: "What is the dress code?",
  answer: "Formal attire is encouraged—think suits for men and dresses for women. Since the venue is in the mountains and evenings can get cool, we recommend bringing a light jacket or scarf."
}, {
  id: 3,
  question: "Are children welcome?",
  answer: "We love your little ones, but we've planned an adults-only celebration to allow all our guests to relax and enjoy the evening."
}, {
  id: 5,
  question: "How do I RSVP?",
  answer: "Please RSVP through our website's RSVP section. We kindly ask that you respond by May 1, 2026."
}, {
  id: 6,
  question: "What hotels do you recommend?",
  answer: "We recommend staying at Terre Brune Hotel, Faqra Club, or InterContinental Mzaar. Each offers special rates using our discount code \"VanessaBrian\"."
}, {
  id: 7,
  question: "Can I bring a plus one?",
  answer: "Due to venue capacity, we can only accommodate guests formally invited on your invitation. Please check your RSVP for details."
}, {
  id: 8,
  question: "Will the ceremony be indoors or outdoors?",
  answer: "The ceremony will take place outdoors in the beautiful mountain setting. We have contingency plans in case of inclement weather."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={ref} className="relative bg-dark-background py-16 overflow-hidden !text-[hsl(0,0%,100%)] md:py-24 !bg-[url(https://vanessabrian.com/wp-content/uploads/2026/02/green-background.jpg)]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl mb-4 !text-[hsl(24,6%,83%)] md:text-4xl lg:text-5xl">
              Frequently Asked Questions
            </h2>
            <p className="text-lg max-w-2xl mx-auto !text-[hsl(24,6%,83%)]">
              Find answers to common questions about our wedding celebration
            </p>
          </div>

          <div className={`transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="bg-light-background/10 backdrop-blur-sm rounded-lg border-border/30 px-6 transition-all duration-300 hover:bg-light-background/15">
                  <AccordionTrigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md font-medium transition-all outline-none focus-visible:ring-[3px] [&[data-state=open]>svg]:rotate-180 text-left text-base py-5 !bg-transparent !text-[hsl(20,6%,90%)] disabled:pointer-events-none disabled:opacity-50 hover:text-primary-hover md:text-lg hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="!text-[hsl(135,30%,85%)] text-base leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}